export enum CovidTitles {
  PATIENT_SUMMARY = 'COVID-19 Screening Patient Summary',
  SUMMARY_INFORMATION = 'COVID-19 Screening Summary Information',
  ERROR_PAGE = 'COVID-19 Screening Confirmation Error Page',
  PATIENT_SELECT = 'COVID-19 Screening Patient Select Screen',
  CONSENT_AND_AGREEMENTS = 'COVID-19 Screening Consent and Agreements',
  REASON_FOR_REQUEST = 'COVID-19 Screening Reason for Request',
  SYMPTOM_INFORMATION = 'COVID-19 Screening Symptom Information',
  INSURANCE_SELECT = 'COVID-19 Screening Insurance Select',
  INSURANCE_INFORMATION = 'COVID-19 Screening Insurance Information',
  CONFIRM_EXISTING_INSURANCE = 'COVID-19 Screening Confirm Existing Insurance',
  HAVE_HEALTH_INSURANCE = 'COVID-19 Screening Have Health Insurance',
  EXISTING_INSURANCE_SEARCH = 'COVID-19 Screening Existing Insurance Search',
  EXISTING_INSURANCE_FOUND = 'COVID-19 Screening Existing Insurance Found',
  NEW_INSURANCE_FOUND = 'COVID-19 Screening New Insurance Found',
  EXISTING_INSURANCE_NOT_FOUND = 'COVID-19 Screening Existing Insurance Not Found',
  SUBSCRIBER_INFO = 'COVID-19 Screening Subscriber Info',
  INSURANCE_CARD_UPLOAD = 'COVID-19 Screening Insurance Card Upload',
  PERSONAL_INFORMATION = 'COVID-19 Screening Personal Information',
  CONFIRMATION_PAGE = 'COVID-19 Screening Confirmation Page',
  SCREENING_INSURANCE = 'COVID-19 Screening Insurance',
  ORDER_CONFIRMATION = 'COVID-19 Screening Order Confirmation',
  ORDER_STATUS = 'COVID-19 Screening Order Status'
}
